import { useApiToast } from 'components/Toaster';
import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { User } from 'services/auth/auth.types';
import { useGetAllUsersMutation } from 'services/user/user.endpoint';
import { useGetStatisticsDataMutation } from 'services/statistic/statistic.endpoint';
import { ENV } from 'utils/env';
import { getJwtToken } from 'features/auth';
import { StatisticsData } from 'services/statistic/statistic.types';

export const useStatisticsVM = () => {

    const [users, setUsers] = useState<Array<User>>([]);
    const [statisticsData, setStatisticsData] = useState<StatisticsData>();
    const [filter, setFilter] = useState<{
        startDate: string;
        endDate: string;
        appvs: { label: string; value: string }[];
    }>({ startDate: '', endDate: '', appvs: [] });
    const jwt = useSelector(getJwtToken);

    const [getStatisticsData, { isLoading: isGetStatisticsDataLoading, isError: isGetStatisticsDataError, isSuccess: isGetStatisticsDataSuccess, error: getStatisticsDataError, data: getStatisticsDataData }] = useGetStatisticsDataMutation();

    const { showApiToast, showErrorToast } = useApiToast();

    const [
        getAllUsers,
        {
            isLoading: isGetAllUsersLoading,
            isError: isGetAllUsersError,
            isSuccess: isGetAllUsersSuccess,
            error: getAllUsersError,
            data: getAllUsersData
        }
    ] = useGetAllUsersMutation();

    useEffect(() => {
        if (isGetAllUsersLoading) return;
        if (isGetAllUsersError && getAllUsersError) {
            showErrorToast(getAllUsersError, {
                message: 'Erreur lors de la récupération des utilisateurs'
            });
            return;
        }
        if (isGetAllUsersSuccess && getAllUsersData) {
            setUsers(getAllUsersData.data);
            return;
        }
    }, [isGetAllUsersLoading, isGetAllUsersError, isGetAllUsersSuccess, getAllUsersError, getAllUsersData]);

    useEffect(() => {
        if (isGetStatisticsDataLoading) return;
        if (isGetStatisticsDataError && getStatisticsDataError) {
            showErrorToast(getStatisticsDataError, {
                message: 'Erreur lors de la récupération des données statistiques'
            });
        }
        if (isGetStatisticsDataSuccess && getStatisticsDataData) {
            setStatisticsData(getStatisticsDataData.data);
            console.log(getStatisticsDataData.data);
        }
    }, [isGetStatisticsDataLoading, isGetStatisticsDataError, isGetStatisticsDataSuccess, getStatisticsDataError, getStatisticsDataData]);

    useEffect(() => {
        getAllUsers(undefined);
        getStatisticsData(undefined);
    }, []);

    const extractData = () => {
        const usersIds = filter.appvs.map((user) => user.value).join(',');
        window.open(`${ENV.API_URL}/app/stats/export?start=${filter.startDate}&end=${filter.endDate}&users=${usersIds}&jwt=${jwt}`, '_blank');
    };

    return {
        filter, 
        setFilter,
        users,
        extractData,
        statisticsData,
        isLoading: isGetStatisticsDataLoading
    };
};
